import { createSelector } from '@reduxjs/toolkit';
import { USER_ROLES } from 'utils/constants';

export const selectAuthSlice = (state) => state.auth;

export const selectUser = createSelector([selectAuthSlice], (authSlice) => authSlice.user);

export const selectIsAdminOrTeamLeader = createSelector(
    [selectUser],
    (user) => !!user?.roles?.some((role) => role === USER_ROLES.ADMIN || role === USER_ROLES.TEAM_LEADER)
);

export const selectIsUserDataRequested = createSelector([selectAuthSlice], (authSlice) => authSlice.isUserDataRequested);

export const selectStreamManagerToken = createSelector([selectAuthSlice], (authSlice) => authSlice.streamManagerToken);
